import { render, staticRenderFns } from "./SeguroSalud.vue?vue&type=template&id=0b74997c&scoped=true&"
import script from "./SeguroSalud.vue?vue&type=script&lang=js&"
export * from "./SeguroSalud.vue?vue&type=script&lang=js&"
import style0 from "./SeguroSalud.vue?vue&type=style&index=0&id=0b74997c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74997c",
  null
  
)

export default component.exports